import { localeChanged } from 'vee-validate'

import {
  removeSuffixPath,
  serverErrorHandler
} from '../modules/client/utilities'

export default function({
  isHMR,
  app,
  store,
  query,
  req,
  res,
  route,
  redirect
}) {
  // If middleware is called from hot module replacement, ignore it
  if (isHMR) return

  if (store.state.locales.length === 0) {
    store.commit('LOCALE', app.i18n.fallbackLocale)
    return
  }

  let locale
  const paths = route.path.split('/')
  if (store.state.locales.includes(paths[paths.length - 1])) {
    locale = paths[paths.length - 1]
  } else if (query.lang) {
    locale = query.lang
  } else if (process.server) {
    locale = req.cookies.locale
    if (!locale) {
      const accepts = require('accepts')
      const language = accepts(req).language(accepts(req).languages())
      if (!(typeof language === 'boolean' && language === false)) {
        locale = language
        if (locale.indexOf('-') !== -1) {
          locale = locale.split('-')[0]
        }
      }
    }
  } else if (store.state.locale) {
    locale = store.state.locale
  }

  if (!locale || store.state.locales.indexOf(locale) === -1) {
    locale = app.i18n.fallbackLocale
  }
  // Set locale
  if (query.lang || store.state.locales.includes(paths[paths.length - 1])) {
    store
      .dispatch('switchLocale', locale)
      .then(f => f)
      .catch(err => serverErrorHandler(err, arguments[0]))
  } else {
    store.commit('LOCALE', locale)
  }
  if (
    process.server &&
    (!req.cookies.locale || req.cookies.locale !== locale)
  ) {
    try {
      res.cookie('locale', locale, {
        maxAge: 60 * 60 * 1000 * 24 * 14, // 2 weeks
        httpOnly: true
      })
    } catch (e) {
      if (
        e.message?.indexOf(
          'Cannot set headers after they are sent to the client'
        ) === -1
      )
        throw e
    }
  }
  app.i18n.locale = store.state.locale

  // Set localize with VeeValidate library
  localeChanged()

  if (store.state.locales.includes(paths[paths.length - 1])) {
    try {
      redirect(removeSuffixPath(route))
    } catch (e) {
      if (
        e.message?.indexOf(
          'Cannot set headers after they are sent to the client'
        ) === -1
      )
        throw e
    }
  }
}
